import { z } from 'zod';
/**
 * Goals a guardian sets with their teen. [Parent step 24]
 *
 * The product reason these exist: a teen job marketplace that only ever shows
 * money is teaching one lesson. A goal reframes the same work as progress
 * towards something the family chose together.
 */
export const goalTypeSchema = z.enum(['EARNINGS', 'EXPERIENCE_HOURS', 'SKILL']);
export const goalStatusSchema = z.enum(['IN_PROGRESS', 'ACHIEVED', 'MISSED']);
export const GOAL_TYPE_LABEL = {
    EARNINGS: 'Earn an amount',
    EXPERIENCE_HOURS: 'Complete some jobs',
    SKILL: 'Build a skill',
};
export const goalSchema = z.object({
    id: z.string(),
    teenId: z.string(),
    teenName: z.string(),
    goalType: goalTypeSchema,
    /** What they are aiming for: minor units for EARNINGS, a count, or a skill. */
    targetValue: z.string(),
    /**
     * Where they are now.
     *
     * Measured goals (earnings, jobs) are computed from real activity at read
     * time rather than stored, so a goal can never quietly disagree with the
     * ledger. A SKILL goal has no measure, and is null.
     */
    currentValue: z.string().nullable(),
    /** 0 to 1 for a measurable goal; null when there is nothing to measure. */
    progress: z.number().min(0).max(1).nullable(),
    targetDate: z.string().nullable(),
    status: goalStatusSchema,
    createdAt: z.string(),
});
export const createGoalInputSchema = z.object({
    /** The teen's publicId. Must be one this guardian is approved for. */
    teenId: z.string().uuid(),
    goalType: goalTypeSchema,
    targetValue: z.string().trim().min(1, 'Set a target').max(100),
    /** ISO date. */
    targetDate: z.string().date().optional(),
});
export const updateGoalInputSchema = z.object({
    status: goalStatusSchema.optional(),
    targetValue: z.string().trim().min(1).max(100).optional(),
    targetDate: z.string().date().nullable().optional(),
});
export const goalListQuerySchema = z.object({
    teenId: z.string().uuid().optional(),
    status: goalStatusSchema.optional(),
});
//# sourceMappingURL=goals.js.map